import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../libs/bulma.min.css';
import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportSelectQueuesByName, valuesAnalyze, changeViewForms, exportUpdateQueues } from '../../../services';
import Loading from '../../Loading/LoadingModule';

import QueueInputsUpdate from './components/QueueInputsUpdate';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';

function EndpointsListById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [queues, setQueues] = useState({});
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchEndpoints = async () => {
    const queueListName = await exportSelectQueuesByName({ names: itemsSelectedToEdit.toString() });
    if(queueListName <= 0) return history.push('/config/fila/lista');
    if(queueListName === undefined) return setLoading(true);
    
    const listQueuesEdited = queueListName.reduce((acc, q) => {
      acc[q.namequeue] = {
        name: q.namequeue,
        music: q.queuemusiconhold,
        strategy: q.queuestrategy,
        autofill: q.queueautofill,
        maxlen: q.queuemaxlen,
        ringinuse: q.queueringinuse,
        announcePosition: q.queueannounceposition,
        announceFrequency: q.queueannouncefrequency,
        announceHoldTime: q.queueannounceholdtime,
        minAnnounceFrequency: q.queueminannouncefrequency,
        queueEntryVarQueue: q.queuesetqueueentryvarqueue,
        wrapuptime: q.queuewrapuptime,
        joinempty: q.queuejoinempty,
        leavewhenempty: q.queueleavewhenempty
      };
      return acc;
    }, {});

    setQueues(listQueuesEdited);
    setLoading(false);
    return true;
  };

  const joinAndEmptyAnalise = (info) => {
    if (info === 'strict') {
      return 'restrito';
    } else if (info === 'yes') {
      return 'sim';
    } else {
      return 'não';
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const elements = await fetchEndpoints();
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar, isNumberNoZero } = valuesAnalyze;

    if(name === 'maxlen' || name === 'announceFrequency' || name === 'minAnnounceFrequency' || name === 'wrapuptime') {
      const checkValueIsNumber = value < 1 ? false : checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeQueue = (item) => {
    const { value } = item;

    setValues(queues[value]);
    toggleIsHidden('#updatequeue-save-button');
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value );
    
    if(!Object.keys(validate).includes(false)) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataQueuesUpdate = async () => {
    const queueUpdate = await exportUpdateQueues(values);

    if (queueUpdate['rowCount']){
      toggleIsHidden('#queue-table');
      toggleIsHidden('#updatequeue-save-button');
      toggleIsHidden('#update-inputs');
      toggleIsHidden('#alert-update-queue');
      return setTimeout(() => {
        history.push('/config/fila/lista');
      }, 3000);
    } else {
      toggleIsHidden('#queue-table');
      toggleIsHidden('#updatequeue-save-button');
      toggleIsHidden('#update-inputs');
      toggleIsHidden('#alert-queue-not-update');
      return setTimeout(() => {
        history.push('/config/fila/lista');
      }, 3000);
    }
    return;
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">LISTA DE FILAS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-queue-not-update" name="alert-queue-not-update" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-queue-not-update') }></button>
            </div>
            <div className="message-body">
              Não foi possível alterar a fila selecionada.
            </div>
          </article>
          <article id="alert-update-queue" name="alert-update-queue" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-update-queue') }></button>
            </div>
            <div className="message-body">
              Fila atualizada com sucesso!
            </div>
          </article>
          <div id="queue-table" className="table-container is-flex-wrap-wrap has-text-centered">
            <table id="tableCalls" className="table is-hoverable is-striped is-11 column is-offset-1">  
                <thead>
                    <tr className='is-size-7 has-text-centered has-background-link-light'>
                    <th scope="col">Sel.</th>
                    <th scope="col">Fila</th>
                    <th scope="col">Música</th>
                    <th scope="col">Estratégia</th>
                    <th scope="col">Segunda Chamada</th>
                    <th scope="col">Descanso</th>
                    <th scope="col">Anúncio Posição</th>
                    <th scope="col">Anún. T. Estimado</th>
                    <th scope="col">Tempo Mínimo An.</th>
                    <th scope="col">Frequência</th>
                    <th scope="col">Entrar se Vazia</th>
                    <th scope="col">Sair se Vazia</th>
                    <th scope="col">Max. Chamadas</th>
                    </tr>
                </thead>
                <tbody>
                {
                  Object.keys(queues).map((queue, index) => {
                    const queueReal = queues[queue];
                    const { name, music, strategy, maxlen, ringinuse, announcePosition, announceFrequency, announceHoldTime, wrapuptime, minAnnounceFrequency, joinempty, leavewhenempty } = queueReal;
                    return (
                      <tr  key={ index } className='is-size-7 has-text-centered'>
                        <td><input name="get-queue" id={ name } type="radio" value={name} onChange={ (e) => handleChangeQueue(e.target)} /></td>
                        <td>{name}</td>
                        <td>{ music === 'default' ? 'padrão' : music }</td>
                        <td>{strategy}</td>
                        <td>{ringinuse === 'yes' ? 'sim' : 'não'}</td>
                        <td>{wrapuptime }</td>
                        <td>{announcePosition === 'yes' ? 'sim' : 'não'}</td>
                        <td>{announceHoldTime === 'yes' ? 'sim' : 'não'}</td>
                        <td>{minAnnounceFrequency}</td>
                        <td>{announceFrequency}</td>
                        <td>{joinAndEmptyAnalise(joinempty)}</td>
                        <td>{joinAndEmptyAnalise(leavewhenempty)}</td>
                        <td>{maxlen}</td>
                      </tr>
                    )
                  })
                }
                </tbody>
            </table>
          </div>
          <hr className="mb-6 px-3"/>
          <div id="update-inputs" className="columns">
            <div className="column is-fullwidth is-offset-1 has-text-centered">
              <div name="queues-update-div" className="">
                  {
                    Object.keys(values).length > 0 ? <QueueInputsUpdate queue={ values } changeValues={ handleChangeValues } /> : null
                  }
              </div>
            </div>
          </div>
          <div id="updatequeue-save-button" className="columns is-hidden">
            <div className="column is-half is-offset-one-quarter has-text-centered">
                <button className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => sendDataQueuesUpdate() } disabled={ disable } >
                      <span className="icon">
                        <FontAwesomeIcon icon={ faSave } fixedWidth />
                      </span>
                      <span>
                        Salvar
                      </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default EndpointsListById;
